import { Image } from "lucide-react";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import { resolveImageDescription } from "@/components/storyboard/image/utils/resolveImageDescription";
import type { ImageDemonstrationData } from "@/types/storyboard";

interface ImageDemonstrationProps {
  /** Older storyboards carry a bare markdown string instead. */
  description: ImageDemonstrationData | string;
}

const ImageDemonstration = ({
  description: payload,
}: ImageDemonstrationProps) => {
  const { title, description } = resolveImageDescription(payload);

  return (
    <ContentBlock title={title ?? undefined} className="prose max-w-full">
      <div
        className="flex items-center justify-center bg-muted rounded-lg p-8 my-4"
        role="img"
        // The title names the picture; without one the caption has to.
        aria-label={title ?? description}
      >
        <div className="text-center text-muted-foreground">
          <Image className="mx-auto h-16 w-16 mb-2" aria-hidden="true" />
          <span className="prose prose-p:inline max-w-full text-xs italic">
            <CourseMarkdown>{description}</CourseMarkdown>
          </span>
        </div>
      </div>
    </ContentBlock>
  );
};

export default ImageDemonstration;
